import React, { useEffect, useState } from 'react'
import map from 'lodash/map'
import find from 'lodash/find'
import Format from './Format'

import '@SiteComponents/SearchDropdown/SearchDropdown.scss'
import './FormatSelection.scss'

const DROPDOWN_OFFSET_Y = 50 // px

export interface IDropdownPosition {
  top: string
  left: string
}

interface FormatSelectionProps {
  readonly selectedFormats: string[]
  readonly availableFormats: string[]
  setSelectedFormats(newSelectedFormats: string[]): void
}

const FormatSelection: React.FC<FormatSelectionProps> = props => {
  const {
    selectedFormats,
    availableFormats,
  } = props

  const [indexForReplacingFormat, setIndexForReplacingFormat] = useState(-1)

  const shouldRenderAddFormat = selectedFormats.length < availableFormats.length

  useEffect(() => {
    const scrollContainer = document.querySelector('.FormatSelection__items') as HTMLDivElement
    const hasClosedFormats = indexForReplacingFormat === -1

    if (scrollContainer) {
      scrollContainer.style.overflowY = hasClosedFormats ? 'scroll' : 'hidden'
    }
  }, [indexForReplacingFormat])

  const handleAddSelectedFormat = () => {
    const formatToAdd = find(availableFormats, availableFormat => !selectedFormats.includes(availableFormat))

    if (formatToAdd) {
      props.setSelectedFormats(selectedFormats.concat(formatToAdd))
    }
  }

  const selectedFormatsList = map(selectedFormats, (format, index) => {
    return (
      <Format
        key={index}
        index={index}
        availableFormats={availableFormats}
        currentFormat={format}
        selectedFormats={selectedFormats}
        setSelectedFormats={props.setSelectedFormats}
        indexForReplacingFormat={indexForReplacingFormat}
        setIndexForReplacingFormat={setIndexForReplacingFormat}
        dropdownOffsetY={DROPDOWN_OFFSET_Y}
      />
    )
  })

  const renderFormatSelection = () => {
    return (
      <ul className="FormatSelection__items">
        {selectedFormatsList}
      </ul>
    )
  }

  const renderAddFormat = () => {
    return (
      <div
        className="FormatSelection__add"
        onClick={handleAddSelectedFormat}
      >
        + Add another format
      </div>
    )
  }

  return (
    <div className="FormatSelection">
      {renderFormatSelection()}
      {shouldRenderAddFormat && renderAddFormat()}
    </div>
  )
}

export default FormatSelection
